module.exports = __webpack_public_path__ + "media/assets/icons/ticket grey-36761afbd6f43cb5d02bf5da22dc4a99.svg";